import * as React from "react"
import {Box, Divider} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";

import {rawMatcherImageSize} from "../../@signals";


export default function RawMatcherTargetActionsZoom() {
	return <Box sx={{ display: 'flex', gap: 2 }}>
		<ButtonIconSeeker
			disabled={rawMatcherImageSize.value === 0}
			icon="magnifying-glass-minus"
			onClick={() => rawMatcherImageSize.value -= 1}
			tooltip="zoom -"
		/>

		<ButtonIconSeeker
			disabled={rawMatcherImageSize.value === 2}
			icon="magnifying-glass-plus"
			onClick={() => rawMatcherImageSize.value += 1}
			tooltip="zoom +"
		/>

		<Divider orientation="vertical" flexItem />
	</Box>
}